module.exports = __webpack_public_path__ + "img-dashboard/register/breadcrumb-user-blue.14467fae.png";